import React, { Component } from "react";
import Validator from "validator";
import propTypes from "prop-types";
import { Form } from "semantic-ui-react";
import { EmailInput, PasswordInput } from "../ui/inputs/inputs";
import { PrimaryButton } from "../ui/button/button";
import { ErrorAlert } from "../ui/alert/alert";
import styles from "./loginForm.css";

class LoginForm extends Component {
	constructor() {
		super();

		this.state = {
			data: {
				email: "",
				password: ""
			},
			loading: false,
			error: ""
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	onChange(e) {
		this.setState({
			data: { ...this.state.data, [e.target.name]: e.target.value }
		});
	}

	onSubmit() {
		const error = this.validate(this.state.data);
		this.setState({ error });

		// Check if there's no errors
		if (Object.keys(error).length === 0) {
			this.setState({ loading: true });
			this.props
				.submit(this.state.data)
				.catch(err =>
					this.setState({ error: err.response.data.error, loading: false })
				);
		}
	}

	validate(data) {
		let error = "";
		if (!Validator.isEmail(data.email) || !data.password)
			error = "Invalid email or password";
		return error;
	}

	render() {
		const { data, error, loading } = this.state;

		return (
			<Form onSubmit={this.onSubmit} loading={loading}>
				{error && <ErrorAlert>{error}</ErrorAlert>}

				<EmailInput
					type="email"
					id="email"
					name="email"
					placeholder="Email"
					onChange={this.onChange}
				/>

				<PasswordInput
					type="password"
					id="password"
					name="password"
					placeholder="Password"
					value={data.password}
					onChange={this.onChange}
				/>

				<PrimaryButton className={styles.button}>Login</PrimaryButton>
			</Form>
		);
	}
}

LoginForm.propTypes = {
	submit: propTypes.func.isRequired
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/forms/loginForm.js